import React from "react";
import { Modal } from "react-bootstrap";
import YouTube from "react-youtube";

const YtVideoModal = ({show, setShow}) => {

    const youtubeId = "asXg9fs_NPc";
    const opts = {
        width: "100%",
        height: "350",
        playerVars: {
            autoplay: 1,
        }
    }

    return (
        <Modal size="lg" show={show}>
            <Modal.Header closeButton onHide={() => setShow(false)}>
                <Modal.Title>Vorstellungsvideo</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{padding: 0, paddingBottom: 0}}>
                <YouTube videoId={youtubeId} opts={opts}/>
            </Modal.Body>
        </Modal>
    );
}
export default YtVideoModal;